export function setFont(doc, IsHeader) {
  if (IsHeader) {
    doc.setFont("calibri", "bold");
    doc.setFontSize(12);
    doc.setTextColor(53, 71, 123);
  } else {
    doc.setFont("calibri", "normal");
    doc.setFontSize(11);
    doc.setTextColor(0, 0, 0); // Black
  }
}
